/* eslint-disable */
import { ReactNode, useEffect } from "react";

import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../store/store";
import { Brand } from "../models/enum/Brand";
import Header from "./nav/Header";
import { changeLanguage, setBrand } from "../store/appSlice";
import { bankKeys, languages } from "../common/constants";

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  const { lang } = useParams();
  const { bankKey } = useParams();
  const dispatch = useAppDispatch();
  const brand = useAppSelector((state) => state.app.brand);

  useEffect(() => {
    restoreBrand();
    restoreLanguage();
  }, []);

  const restoreBrand = () => {
    let resolvedBrand = "1";

    if (bankKey) {
      Object.entries(bankKeys).forEach(([k, v]) => {
        if (v === bankKey) {
          resolvedBrand = "1";

          if (k === "0") { // Demo mode (used to enforce addProtect white label design)
            localStorage.setItem("demo", "1");
          } else {
            localStorage.removeItem("demo");
          }

          return;
        }
      });
    } else {
      resolvedBrand = localStorage.getItem("brand") ?? "1";
    }

    dispatch(setBrand(Number(resolvedBrand)));
    localStorage.setItem("brand", resolvedBrand);
  };

  const restoreLanguage = () => {
    let resolvedLang = "";

    if (lang && languages.includes(lang)) {
      resolvedLang = lang;
    } else if (!lang && bankKey && languages.includes(bankKey)) {
      resolvedLang = bankKey;
    } else {
      if (!languages.includes(resolvedLang)) {
        const browserLang = localStorage.getItem("lang") ?? navigator.language;

        if (browserLang === "fr" || browserLang.startsWith("fr-")) {
          resolvedLang = "fr";
        } else if (browserLang === "it" || browserLang.startsWith("it-")) {
          resolvedLang = "it";
        } else if (browserLang === "en" || browserLang.startsWith("en-")) {
          resolvedLang = "en";
        } else if (languages.includes(browserLang)) {
          resolvedLang = browserLang;
        }

        resolvedLang = resolvedLang ?? "en";
      }
    }

    if (resolvedLang) {
      dispatch(changeLanguage(resolvedLang));
      localStorage.setItem("lang", resolvedLang);
    }
  };

  return (
    <div className={`tenant ${Brand[brand || 1]}`}>
      <Header showMenuIcon={false} />
      <main>
        <div className="container min-h-full max-h-min">{children}</div>
      </main>
    </div>
  );
};
